import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import React, { useState, useRef, useEffect } from "react";

import { useGetQuickFiltersQuery } from "../../redux/modules/catalog";

const QuickFilters = ({ setFilter, filter }) => {
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);
  const sliderRef = useRef(null);
    const { data } = useGetQuickFiltersQuery({}, { skip: false });

  const checkArrows = () => {
    if (sliderRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = sliderRef.current;
      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 10);
    }
  };

  useEffect(() => {
    checkArrows();
    const slider = sliderRef.current;
    if (slider) {
      slider.addEventListener("scroll", checkArrows);
      return () => slider.removeEventListener("scroll", checkArrows);
    }
  }, []);

  const scroll = (direction) => {
    if (sliderRef.current) {
      const scrollAmount = 300;
      if (direction === "left") {
        sliderRef.current.scrollBy({ left: -scrollAmount, behavior: "smooth" });
      } else {
        sliderRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
      }
    }
  };

  return (
    <div className="relative w-full mt-6">
      <div className="flex gap-2">
        <h2 className="text-[14px] font-[600] mb-3 text-[#0A1321]">
          Quick Filters
        </h2>
        {filter && (
          <h2
            className="text-[14px] font-[600] mb-3 text-[#3581E3]"
            onClick={() => setFilter(null)}
          >
            Clear Filter
          </h2>
        )}{" "}
      </div>
      <div className="relative">
        {showLeftArrow && (
          <div className="absolute left-0 top-0 h-full w-12 bg-gradient-to-l from-transparent to-white z-10"></div>
        )}

        {showLeftArrow && (
          <button
            className="absolute -left-2 top-1/2 transform -translate-y-1/2 bg-transparent z-20 p-1"
            onClick={() => scroll("left")}
            aria-label="Scroll left"
          >
            <ChevronLeft size={24} className="text-gray-600" />
          </button>
        )}

        <div
          ref={sliderRef}
          className="flex overflow-x-auto scrollbar-hide gap-2"
          style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
        >
          {data?.quickFilters?.map((value, index) => (
            <div
              key={index}
              onClick={() => setFilter(value)}
              style={{
                border:
                  filter === value ? "1px solid #3581E3" : "1px solid #E7E8E9",
                color: filter === value ? "#3581E3" : "#0A1321",
                backgroundColor: filter === value ? "transparent" : "#F7F9FB"
              }}
              className="text-[14px] whitespace-nowrap px-[18px] py-2 rounded-[8px] hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 transition-colors"
            >
              {value}
            </div>
          ))}
        </div>

        {/* Right gradient blur effect */}
        {showRightArrow && (
          <div className="absolute right-0 top-0 h-full w-12 bg-gradient-to-l from-white to-transparent z-10"></div>
        )}

        {/* Right arrow button */}
        {showRightArrow && (
          <button
            className="absolute -right-2 top-1/2 transform -translate-y-1/2 bg-transparent z-20 p-1"
            onClick={() => scroll("right")}
            aria-label="Scroll right"
          >
            <ChevronRight size={24} className="text-gray-600" />
          </button>
        )}
      </div>
    </div>
  );
};

export default QuickFilters;
